import { render, staticRenderFns } from "./ExerciseCard.vue?vue&type=template&id=244e71a8&scoped=true"
import script from "./ExerciseCard.vue?vue&type=script&lang=js"
export * from "./ExerciseCard.vue?vue&type=script&lang=js"
import style0 from "./ExerciseCard.vue?vue&type=style&index=0&id=244e71a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e71a8",
  null
  
)

export default component.exports